function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../text';
import { withModifiers } from '../../decorators';

var Title = function Title(_ref) {
  var _classNames;

  var allowi18nhtml = _ref.allowi18nhtml,
      asTag = _ref.asTag,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      size = _ref.size,
      subtitle = _ref.subtitle,
      others = _objectWithoutProperties(_ref, ["allowi18nhtml", "asTag", "children", "className", "content", "size", "subtitle"]);

  var text = content || children;
  var classes = classNames((_classNames = {
    title: !subtitle,
    subtitle: subtitle
  }, _defineProperty(_classNames, "is-size-".concat(size), Boolean(size) && !subtitle), _defineProperty(_classNames, "is-size-".concat(size + 2, "-mobile"), Boolean(size) && !subtitle && size === 1), _defineProperty(_classNames, "is-".concat(size), Boolean(size) && !subtitle && size !== 1), _classNames), className);
  return React.createElement("".concat(asTag || "h".concat(size)), _objectSpread({
    className: classes
  }, others), React.createElement(Title.Text, _extends({
    asTag: "span"
  }, {
    allowi18nhtml: allowi18nhtml,
    content: text
  })));
};

Title.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  asTag: PropTypes.string,
  size: PropTypes.number.isRequired,
  subtitle: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  allowi18nhtml: PropTypes.bool
};
Title.defaultProps = {
  size: 1
};
Title.Text = Text;
export default withModifiers(Title);